import { WageType } from '@zorro/clients';
import { Select, type SelectProps } from '@zorro/design-system/v2/Select';
import { wageTypeLabelConfig } from '@zorro/types';
import { ForwardedRef, forwardRef } from 'react';
import { ControllerRenderProps, Path } from 'react-hook-form';

const wageTypeOptions = Object.values(WageType).map((status) => ({
  label: wageTypeLabelConfig[status],
  value: status,
}));

type WageTypeFieldValues = {
  wageType?: WageType | null;
};
type Props<T extends WageTypeFieldValues, U extends Path<T>> = Omit<
  ControllerRenderProps<T, U>,
  'ref'
> & { selectProps?: SelectProps };

export const WageTypeInput = forwardRef(
  <T extends WageTypeFieldValues, U extends Path<T>>(
    { selectProps, ...field }: Props<T, U>,
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    return (
      <Select
        {...field}
        {...selectProps}
        ref={ref}
        label="Wage type"
        size="lg"
        placeholder="Select wage type"
        data={wageTypeOptions}
      />
    );
  }
);

WageTypeInput.displayName = 'WageTypeInput';
